module.exports = __webpack_public_path__ + "img/academia.b107ce09.svg";